import { render, staticRenderFns } from "./WhatsappChat.vue?vue&type=template&id=1c22ca0e&scoped=true"
import script from "./WhatsappChat.vue?vue&type=script&lang=js"
export * from "./WhatsappChat.vue?vue&type=script&lang=js"
import style0 from "./WhatsappChat.vue?vue&type=style&index=0&id=1c22ca0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c22ca0e",
  null
  
)

export default component.exports